export const validateCompanyDetails = (companyDetailsFormValues , isSubsidiaryOrDivision) =>{
    
    let isValidCheckMsg=isValid(companyDetailsFormValues);
    if(isValidCheckMsg)
        return isValidCheckMsg;
    
    if(companyDetailsFormValues.companyName.trim() === "" || !companyDetailsFormValues.companyName){
        return 'Company name cannot be empty!';
    }
    if(companyDetailsFormValues['company-address1'] === "" || companyDetailsFormValues['company-address1'] === undefined){
        return 'Please enter company address!';
    }
    if(companyDetailsFormValues['company-address-state'] === 'Select state' || companyDetailsFormValues['company-address-state'] === undefined){
        return 'Please select state!';
    }
    if(companyDetailsFormValues['company-address-city'] === "" || companyDetailsFormValues['company-address-city'] === undefined){
        return 'City is required!';
    }

    if(companyDetailsFormValues.zipCode === '' || companyDetailsFormValues.zipCode === undefined){
        return 'Zip code is required!';
    }
    if(isSubsidiaryOrDivision && 
        (companyDetailsFormValues['corporate-type'] === '' || companyDetailsFormValues['corporate-type'] === undefined)){
        return 'Please select corporate type';
    }

    if((companyDetailsFormValues['GST-Number'] === '' || companyDetailsFormValues['GST-Number'] === undefined) && (companyDetailsFormValues['PAN-Number'] === '' || companyDetailsFormValues['PAN-Number'] === undefined)){
        return 'Either GST or PAN is required';
    }
    
    if(companyDetailsFormValues['GST-Number']){
        if(companyDetailsFormValues['GST-Number'].length !== 15){
            return 'GST is not correct';
        }
    }

    if(companyDetailsFormValues['PAN-Number']){
        if(companyDetailsFormValues['PAN-Number'].length !== 10){
            return 'PAN is not correct';
        }
    }
    if((companyDetailsFormValues['corporate-category'] === '' || !companyDetailsFormValues['corporate-category']) || companyDetailsFormValues['corporate-category'] === 'Select Category'){
        return 'Please select corporate category';
    }

    return '';
}

const isValid=(companyDetailsFormValues)=>
{
    for (let key in companyDetailsFormValues) {
        let value=companyDetailsFormValues[key];
        if(typeof value=='string')
        {
            let res= !value||value.match(/^[^<>!$%^?*~`{}=]*$/) ? null :'Please enter valid Input';
            if(res)
            {
                return res;
            }
        }
    }
    
    return null;
    
}